// extracted by mini-css-extract-plugin
export default {"root":"BrandingEdit_root__EW4Wa","defaultIcon":"BrandingEdit_defaultIcon__OT+G6","defaultIconActive":"BrandingEdit_defaultIconActive__n8QoL"};